var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-table-bottom"},[_c('div',[_vm._v("制表："+_vm._s(_vm.userName))]),_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("技术部确认：")]),_c('div',[_vm._v("日期：")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("设计部确认：")]),_c('div',[_vm._v("日期：")])])
}]

export { render, staticRenderFns }